
export const ADD_TOPIC_NOTES = 'ADD_TOPIC_NOTES';
export const  GET_TOPIC_NOTES = ' GET_TOPIC_NOTES';
export const EDIT_TOPIC_NOTES = 'EDIT_TOPIC_NOTES';
export const DELETE_TOPIC_NOTES = 'DELETE_TOPIC_NOTES';